import { render, staticRenderFns } from "./chooseFrequentlyUsedAddress.vue?vue&type=template&id=ae09050e&scoped=true&"
import script from "./chooseFrequentlyUsedAddress.vue?vue&type=script&lang=js&"
export * from "./chooseFrequentlyUsedAddress.vue?vue&type=script&lang=js&"
import style0 from "./chooseFrequentlyUsedAddress.vue?vue&type=style&index=0&id=ae09050e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae09050e",
  null
  
)

export default component.exports